// src/Layout.js
import React from "react";
import { useLocation } from "react-router-dom";
import NavBar from "./Components/NavBar/NavBar";
import Footer from "./Components/Footer/Footer";
import {Warning} from "./Components/Warning/Warning";

export default function Layout({ children }) {
  const location = useLocation();

  return (
    <div className="app">
      <NavBar />

      {/* Warning vises kun på ALLE sider undtagen Home */}
      {location.pathname !== "/" && <Warning />}

      <main className="main-content">{children}</main>

      <Footer />
    </div>
  );
}
